/* eslint-disable react/prop-types */
/* eslint-disable jsx-a11y/no-static-element-interactions */

import React from 'react'
import styled from 'styled-components'
import { Tooltip } from 'antd'

const EditableStyledWrapper = styled.div`
`

const EditableStyledItem = styled.span`
  width: 70px;
  height: 100%;
  background: #FFFFFF;
  font-weight: 400;
  font-size: 9px;
  /* or 267% */
  line-height: 22px;
  min-height: 22px;
  display: block;
  text-align: center;
  letter-spacing: 1px;
  text-transform: uppercase;
  white-space: nowrap;
  overflow: hidden !important;
  text-overflow: ellipsis;

  color: #000000;
`

// Component accept text, placeholder values and also pass what type of Input - input, textarea so that we can use it for styling accordingly
const Editable = ({
  text,
  type,
  placeholder,
  children,
  isEditField,
  ...props
}) => {
  // Event handler while pressing any key while editing
  // eslint-disable-next-line no-shadow
  const handleKeyDown = () => {
  }
  return (
    <EditableStyledWrapper {...props}>
      {isEditField ? (
        <EditableStyledWrapper
          onKeyDown={(e) => handleKeyDown(e, type)}
        >
          {children}
        </EditableStyledWrapper>
      ) : (
        <EditableStyledWrapper>
          <Tooltip title={text}>
            <EditableStyledItem>
              {text}
            </EditableStyledItem>
          </Tooltip>
        </EditableStyledWrapper>
      )}
    </EditableStyledWrapper>
  )
}

export default Editable
